import { Box, Button, Paper } from '@mui/material'
import React from 'react'
import styles from './twoChoiceDialogStyle'

interface Props {
  title: string
  message: string
  cancelDisplayValue?: string
  proceedDisplayValue?: string
  onClose: () => void
  functionCall?: () => void
}
const TwoChoiceDialog = (props: Props) => {
  const {
    title,
    message,
    cancelDisplayValue = 'No',
    proceedDisplayValue = 'Yes',
    onClose,
    functionCall,
  } = props

  const handleOnClick = () => {
    functionCall && functionCall()
    onClose()
  }

  return (
    <Paper elevation={3} sx={styles.container}>
      <Box component={'h1'} sx={styles.title}>
        {title}
      </Box>
      <Box component={'p'} sx={styles.message}>
        {message}
      </Box>
      <div style={{ textAlign: 'right' }}>
        <Button sx={styles.button} onClick={onClose}>
          {cancelDisplayValue}
        </Button>
        <Button
          color="primary"
          sx={styles.button}
          onClick={() => {
            handleOnClick()
          }}
        >
          {proceedDisplayValue}
        </Button>
      </div>
    </Paper>
  )
}

export default TwoChoiceDialog
